import React from 'react'
import { Button } from 'antd'
import { useTranslation } from 'next-i18next'
import { useAppSelector } from 'src/app/hooks'
import { Currency, Deposit } from 'src/core/models'
import styles from './DownloadAllDeposits.module.scss'
import { CloudDownloadOutlined } from '@ant-design/icons'
import { ExcelFile, getActualDateFormated, showNotification } from 'src/core/helpers'
import {
  completedDepositsSelector,
  currencyListSelector
} from 'src/features'


const DownloadAllDeposits = () => {
  const { t } = useTranslation()
  const deposits = useAppSelector(completedDepositsSelector)
  const currencyList = useAppSelector(currencyListSelector)
  const currencyCode = (cId: number) => currencyList?.find((c: Currency) => c.id === cId)?.code

  const handleClick = () => {
    if (deposits.length === 0) {
      showNotification('error', t('Deposits.NoCompletedError'))
      return
    }
    downloadDepositsCSV()
  }

  const downloadDepositsCSV = () => {
    const depositsData = deposits.map((deposit: Deposit) => {
      return {
        'Date': deposit.created,
        'Reference': deposit.internal_reference,
        'Total': deposit.amount.toFixed(2),
        'Currency': currencyCode(deposit.currency_token_id)
      }
    })
    const excel = new ExcelFile(depositsData)
    const fileName = `Transactions_${getActualDateFormated()}`
    excel.downLoad(fileName)
  }

  return (
    <Button
      icon={<CloudDownloadOutlined />}
      className={styles['button']}
      onClick={handleClick}
    >
      {t('Deposits.ExportAll')}
    </Button>
  )
}

export default DownloadAllDeposits
